/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, message, Modal, Input, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import axios from "axios";
import dot from 'dot-object';
import { useTranslation } from "react-i18next";
import DynamicForm from "..";
import Loading from "../../Loading";
import DynamicView from "../../DynamicViewNew";
import { getInputProp } from "../../../screens/Edit/helper";
import { propHasValue } from '../helper';
import { getToken } from 'datastake-daf/src/helpers/Token';
import { ModalHeader } from "datastake-daf/dist/components";
import { getApiBaseUrl, getAppHeader } from "../../../services/BaseService";

const Styles = styled.div`
	width: 100%;
	.form-loader {
		position: absolute;
		right: 0;
		top: 55px;
		left: 0;
		bottom: 0;
		.loader{
			position: absolute;
		}
	}
	.ant-modal-body{
		max-height: 500px;
		width: 700px;
		overflow-y: auto;
		padding: 0px;
	}
`;

function AjaxModal({
  authentication: { user },
  formsValue = {},
  name,
  inputName = null,
  props = {},
  call = null,
  automaticallyLink = null,
  value = null,
  onNewSetValue = null,
  modalTitle = null,
  buttonText = null,
  repeatIndex = null,
  repeatValues = {},
  updateOptions = false,
  mainForm = null,
  onChange = () => { },
  onOptions = () => { }
}) {
  const endpoint = `${getApiBaseUrl()}/linking/data`;
  const createEndpoint = `${getApiBaseUrl()}/linking/check`;

  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [config, q, v, d, opFilters, noDelete] = call.split('::');
  const [isFetching, setIsFetching] = useState(true);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [form, setForm] = useState({});
  const [data, setData] = useState({});
  const [disabledInputs, setDdisabledInputs] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [currentValue, setCurrentValue] = useState(value);
  const [destroy, setDestory] = useState(false);

  useEffect(() => {
    if ((modalVisible || value || (data && data.id !== value)) && isFetching) {
      const query = q ? JSON.parse(q) : {};
      query.module = 'pme';
      if (value) {
        query.parent = value;
        setCurrentValue(value);
      }
      if (formsValue && formsValue.id) {
        query.entityId = formsValue.id;
      }
      const dInputs = d ? JSON.parse(d) : [];
      const requestConfig = config ? JSON.parse(config) : {};
      setDdisabledInputs(dInputs);
      axios.post(endpoint, {
        ...requestConfig,
        query
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      }).then(({ data }) => {
        if (data) {
          let optionFilters = [];
          try {
            optionFilters = JSON.parse(opFilters);
          } catch {

          }
          const form = data.form || {};
          if (optionFilters.length) {
            optionFilters.filter(f => f.path && (f.includes || f.set)).forEach(f => {
              if (f.set) {
                dot.set(f.path, f.set, form);
              } else {
                let options = dot.pick(f.path, form);
                if (options && Array.isArray(options)) {
                  options = options.filter(o => f.includes.includes(o.value));
                  dot.set(f.path, options, form);
                }
              }
            })
          }
          const dPaths = noDelete ? JSON.parse(noDelete) : [];
          dPaths.forEach(k => {
            if (typeof dot.pick(k, form) === 'object') {
              dot.set(`${k}.deleteDataOnHide`, false, form);
            }
          })
          setForm(form);
          const extraData = [];
          if (!data.data || !data.data.country) {
            extraData.push('country');
          }
          const formData = Object.assign(data.data || {}, getPredfinedValues(v ? JSON.parse(v) : {}, extraData));
          setData(formData);
          if (value) {
            setCurrentData(formData);
          }
        }
        setIsFetching(false);
      }).catch((e) => {
        console.log(e);
        setIsFetching(false);
      });
    } else {
      const extraData = [];
      if (!data || !data.country) {
        extraData.push('country');
      }
      const formData = Object.assign(data || {}, getPredfinedValues(v ? JSON.parse(v) : {}, extraData));
      setData(formData);
    }
  }, [modalVisible, value, isFetching])

  const getPredfinedValues = (predefinedValues, fromForm = []) => {
    Object.keys(predefinedValues).forEach(pv => {
      if (typeof predefinedValues[pv] === 'string' && predefinedValues[pv].split('./').length > 1) {
        let field = predefinedValues[pv].split('./')[1];
        if (field.split('[]').length > 1) {
          field = field.split('[]')[1];
          predefinedValues[pv] = dot.pick(field, repeatValues);
        } else {
          predefinedValues[pv] = dot.pick(field, formsValue);
        }
      }
    })
    if (formsValue && formsValue[name]) {
      let preselectedValues = formsValue[name];
      if (Array.isArray(preselectedValues) && inputName) {
        preselectedValues = preselectedValues.map(pv => pv[inputName]).filter(pv => pv);
      } else if (typeof preselectedValues === 'object' && inputName) {
        preselectedValues = [preselectedValues[inputName]].filter(pv => pv);
      } else if (typeof preselectedValues === 'string') {
        preselectedValues = [preselectedValues].filter(pv => pv);
      } else {
        preselectedValues = [];
      }
      if (Array.isArray(preselectedValues) && preselectedValues.length > 0) {
        predefinedValues.preSelected = preselectedValues;
      }
    }
    fromForm.forEach(n => {
      predefinedValues[n] = formsValue[n];
    })
    return predefinedValues;
  }

  function submit(payload, setNextForm) {
    const requestConfig = config ? JSON.parse(config) : {};
    Object.keys(payload).forEach(key => {
      if (typeof payload[key] === 'object' && payload[key] !== null && propHasValue(payload[key])) {
        if (Object.keys(payload[key]).includes('fileList')) {
          const file = (payload[key].fileList || [])
            .map(file => file.response ? file.response : file)
            .filter(file => file && file.status === 'done');
          payload[key] = !Array.isArray(file)
            ? file : file.filter((v, i, a) => a.indexOf(v) === i);
        } else {
          Object.keys(payload[key]).forEach(oKey => {
            if (typeof payload[key][oKey] === 'object' && payload[key][oKey] !== null && propHasValue(payload[key][oKey]) &&
              Object.keys(payload[key][oKey]).includes('fileList')) {
              const file = (payload[key][oKey].fileList || [])
                .map(file => file.response ? file.response : file)
                .filter(file => file && file.status === 'done');
              payload[key][oKey] = !Array.isArray(file)
                ? file : file.filter((v, i, a) => a.indexOf(v) === i);
            }
          })
        }
      }
      if (Array.isArray(payload[key])) {
        // remove empty arrays
        payload[key] = payload[key].filter(f => typeof f !== 'object' || (Object.keys(f).length > 0 && Object.keys(f).filter(fk => propHasValue(f[fk])).length > 0));
      }
    });
    axios.post(createEndpoint, {
      ...requestConfig,
      data: Object.assign(payload, getPredfinedValues(v ? JSON.parse(v) : {})),
    }, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      },
    }).then(({ data }) => {
      setIsFetching(false);
      setNextForm(false);
      setCurrentData(data);
      setData(data);
      const [, dataId] = onNewSetValue.split('=');
      setCurrentValue(dot.pick(dataId, data))
      onChange(dot.pick(dataId, data));
      setModalVisible(false);
    }).catch((e) => {
      console.log(e);
      message.error(e.response && e.response.data ? e.response.data.message : e.message);
      setNextForm(false)
      setIsFetching(false);
    })
  }

  useEffect(() => {
    if (destroy) {
      setDestory(false);
    }
  }, [destroy]);

  function checkForAutomaticallyLink() {
    setCurrentData({});
    const oldValue = currentValue;
    setCurrentValue(null);
    onChange(null);
    const formData = Object.assign({}, getPredfinedValues(v ? JSON.parse(v) : {}, ['country']));
    if (formData.preSelected && Array.isArray(formData.preSelected)) {
      formData.preSelected = formData.preSelected.filter(p => p !== oldValue);
    }
    setDestory(true);
    setData(formData);
    setDeleteConfirmVisible(false);
  }

  return <Styles>
    <Modal
      style={{ width: '700px' }}
      bodyStyle={{ maxHeight: "500px", width: "100%", overflowY: "auto", padding: "0px" }}
      title={(
        <ModalHeader
          title={getInputProp(modalTitle, formsValue) || "Link Stakeholder"}
        />
      )}
      open={modalVisible}
      footer={false}
      maskClosable={false}
      onCancel={() => {
        setData({})
        setModalVisible(!modalVisible);
      }}
      destroyOnClose={destroy}
    >
      {modalVisible ? (isFetching ?
        <div className="form-loader"><Loading /></div>
        :
        <DynamicForm
          form={form}
          data={data}
          checkDuplicates={false}
          showSaveAndNext={false}
          disabledInputs={disabledInputs}
          submit={(payload, setNextForm) => {
            submit(payload, setNextForm);
          }}
        />
      ) : null}
    </Modal>
    {currentData && Object.keys(currentData).length > 0 ? (<React.Fragment>
      <DynamicView showTitle={false} form={form} data={currentData}></DynamicView>
      {repeatIndex === null && <div style={{ display: 'inline' }}>
        <Popconfirm
          title={t('unlinkData')}
          open={deleteConfirmVisible}
          onConfirm={checkForAutomaticallyLink}
          onCancel={() => {
            setDeleteConfirmVisible(false);
          }}
        >
          <Button style={{ margin: '15px 0px 15px' }} type="dashed" onClick={() => {
            setDeleteConfirmVisible(true)
          }} block danger icon={<DeleteOutlined />}>
            {t('Remove')}
          </Button>
        </Popconfirm>
      </div>}
    </React.Fragment>
    ) : (
      <Button style={{ height: '70px' }} type="dashed" icon={<PlusOutlined />} block onClick={() => setModalVisible(!modalVisible)}>{getInputProp(buttonText, formsValue) || t('Link')}</Button>
    )}
    <Input {...props} value={currentValue} hidden></Input>
  </Styles>
}

const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(AjaxModal);
